import axios from '../../axios'

// 获取用户列表
export const getUserList = data => {
    return axios({
        url: '/api/admin/mobile/info/page',
        method: 'POST',
        data
    })
}

// 手机号导入
export const importMobile = data => {
    return axios({
        url: '/api/admin/mobile/info/import',
        method: 'POST',
        data
    })
}

// 平均分配
export const divisionEqual = data => {
    return axios({
        url: '/api/admin/mobile/sale/equal/division',
        method: 'PUT',
        data
    })
}

// 逐个分配
export const divisionSingle = data => {
    return axios({
        url: '/api/admin/mobile/sale/single/division',
        method: 'PUT',
        data
    })
}

// 教师列表
export const getTeacherList = () => {
    return axios({
        url: '/api/admin/mobile/info/teacher/list',
        method: 'GET'
    })
}

// 所有用户统计
export const getUserCount = () => {
    return axios({
        url: '/api/admin/mobile/info/count',
        method: 'GET'
    })
}

// 今日登陆统计
export const getTodayUserCount = () => {
    return axios({
        url: '/api/admin/mobile/info/today/count',
        method: 'GET'
    })
}

// 线索用户统计
export const getLeadUserCount = () => {
    return axios({
        url: '/api/admin/mobile/info/lead/count',
        method: 'GET'
    })
}

// 引导试用统计
export const getTryCount = () => {
    return axios({
        url: '/api/admin/mobile/info/try/count',
        method: 'GET'
    })
}

// 停留温馨提示统计
export const getTipCount = () => {
    return axios({
        url: '/api/admin/mobile/info/tips/count',
        method: 'GET'
    })
}

// 公海打捞统计
export const getSeaCount = () => {
    return axios({
        url: '/api/admin/mobile/info/salvage/count',
        method: 'GET'
    })
}

// 待付款/今日已关闭
export const getClosedCount = () => {
    return axios({
        url: '/api/admin/mobile/info/nopay/order/count',
        method: 'GET'
    })
}
// 转介绍
export const getIntroCount = () => {
    return axios({
        url: '/api/admin/mobile/info/intro/count',
        method: 'GET'
    })
}
// 累计成交统计
export const getStatCount = () => {
    return axios({
        url: '/api/data/wish/order/stat',
        method: 'GET'
    })
}

// 好友状态 已加 和 未添加 状态更新
export const setFriendStatus = data => {
    return axios({
        url: '/api/admin/mobile/info/update/friends/status',
        method: 'PUT',
        data
    })
}

// 接听状态 已接 和 未接通 状态更新
export const setConnectStatus = data => {
    return axios({
        url: '/api/admin/mobile/info/update/connect/status',
        method: 'PUT',
        data
    })
}

// 使用状态更新
export const setCodeStatus = data => {
    return axios({
        url: '/api/admin/mobile/info/update/qrcode/status',
        method: 'PUT',
        data
    })
}

// 跟踪备注分页查询
export const getUserRemarkList = data => {
    return axios({
        url: '/api/admin/mobile/remark/page',
        method: 'GET',
        data
    })
}

// 新增跟踪备注
export const setUserRemark = data => {
    return axios({
        url: '/api/admin/mobile/remark/save',
        method: 'PUT',
        data
    })
}

// 转介绍分页查询
export const getIntroductionList = data => {
    return axios({
        url: '/api/admin/mobile/introduction/user/page',
        method: 'GET',
        data
    })
}

// 日志分页查询
export const getLogList = data => {
    return axios({
        url: '/api/admin/mobile/operate/log/page',
        method: 'GET',
        data
    })
}

// 用户信息查询
export const getUserInfo = data => {
    return axios({
        url: '/api/admin/mobile/info/get',
        method: 'GET',
        data
    })
}

// 查看海报
export const getUserPoster = data => {
    return axios({
        url: '/api/admin/mobile/info/poster/url/generate',
        method: 'PUT',
        data
    })
}

export const sendMessage = data => {
    return axios({
        url: '/api/admin/mobile/info/sms/send',
        method: 'PUT',
        data
    })
}

// 获取分配用户模式
export const getAssignMode = () => {
    return axios({
        url: '/api/admin/mobile/sale/auto/division/get',
        method: 'get'
    })
}
// 获取分配用户模式
export const saveAuto = data => {
    return axios({
        url: '/api/admin/mobile/sale/auto/division/save',
        method: 'post',
        data
    })
}
// 更新转介绍截图
export const updateIntro = data => {
    return axios({
        url: '/api/admin/mobile/info/upload/intro/url',
        method: 'post',
        data
    })
}

// 公海打捞人数查询
export const getPoolDataNum = data => {
    return axios({
        url: '/api/admin/mobile/info/high/seas/count',
        method: 'get',
        data
    })
}

// 公海打捞列表查询
export const getPoolList = data => {
    return axios({
        url: '/api/admin/mobile/info/salvage/query',
        method: 'post',
        data
    })
}

// 公海打捞人
export const savePoolData = data => {
    return axios({
        url: '/api/admin/mobile/info/salvage/save',
        method: 'post',
        data
    })
}

// 工作统计查询
export const getWorkStat = data => {
    return axios({
        url: '/api/admin/mobile/info/teacher/stat',
        method: 'post',
        data
    })
}

// 下单标记提交
export const saveOrderFlag = data => {
    return axios({
        url: '/api/admin/mobile/order/mark/save',
        method: 'post',
        data
    })
}

// 下单标记列表
export const getOrderFlagList = data => {
    return axios({
        url: '/api/admin/mobile/order/mark/page',
        method: 'get',
        data
    })
}

// 审核下单标记申请
export const updateOrderFlag = data => {
    return axios({
        url: '/api/admin/mobile/order/mark/update',
        method: 'put',
        data
    })
}

// 手机号导出
export const exportMobileList = data => {
    return axios({
        url: '/api/admin/mobile/info/export',
        method: 'post',
        data
    })
}

// 飞鸽登录账号
export const getFeigeLoginInfo = data => {
    return axios({
        url: '/api/admin/feige/telephone/call/options',
        method: 'get',
        data
    })
}
// 飞鸽拨打电话回调
export const getFeigeCallInfo = data => {
    return axios({
        url: '/api/admin/call/record/feign/notify',
        method: 'post',
        data
    })
}

// 飞鸽线路呼叫
export const getFeigeCall = data => {
    return axios({
        url: '/api/admin/feige/call',
        method: 'post',
        data
    })
}

// 飞鸽发送短信
export const sendFeigeInfo = data => {
    return axios({
        url: '/api/admin/feige/sms/send',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/crm/crm.js